import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./AboutUs.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import hero2 from "../../assets/LandingPage/one-region-two-horizons.jpg";
import shuakheviMap from "../../assets/aboutUs/shuakhevi-location-map.svg";
import hero4 from "../../assets/aboutUs/hero4.jpg";
import hero5 from "../../assets/aboutUs/hero5-new-chapter.jpg";
import hero5b from "../../assets/aboutUs/hero5-new-chapter-mountain.jpg";
import cultureCenterBuilding from "../../assets/aboutUs/shuakhevi-culture-center-building.jpg";
import historyBtsFilming from "../../assets/aboutUs/history-bts-filming.jpg";
import year2022 from "../../assets/HistoryPage/HistoryYearPhotos/history-2022.jpg";
import year2023 from "../../assets/HistoryPage/HistoryYearPhotos/history-2023.jpg";
import year2025 from "../../assets/HistoryPage/HistoryYearPhotos/history-2025.jpg";
import { useLanguage } from "../../i18n/LanguageContext";
import { about, footer, history } from "../../i18n/content";

const AboutUs = () => {
  const { t } = useLanguage();
  const [openYear, setOpenYear] = useState(null);
  const toggle = (year) => setOpenYear(openYear === year ? null : year);

  return (
    <div className="about_us_test_wrapper">
      <header className="lw-page-hero">
        <div className="lw-wrap">
          <div className="lw-eyebrow">
            <span className="lw-dot" />
            {t(about.eyebrow)}
          </div>
          <h1>{t(about.title)}</h1>
          <p>{t(about.lede)}</p>
        </div>
      </header>

      <section className="lw-about">
        <div className="lw-wrap lw-frame-grid">
          <div>
            <span className="lw-kicker">{t(about.s1Kicker)}</span>
            <h2 className="lw-h-title">{t(about.s1Title)}</h2>
            <p>{t(about.s1P1)}</p>
            <p>{t(about.s1P2)}</p>
          </div>
          <div className="lw-about-visual">
            <img src={hero2} alt="Adjarian Film Tales festival scene" />
            <div className="lw-reel-overlay" />
            <div className="lw-tag">
              <span>{t(about.tagAdjara)}</span>
              <span>9:16</span>
            </div>
          </div>
        </div>
      </section>

      <section className="lwt-split">
        <div className="lw-wrap lw-frame-grid">
          <div className="lw-about-visual lw-about-visual--map">
            <img src={shuakheviMap} alt="Outline map of Shuakhevi Municipality, Adjara" />
            <div className="lw-tag">
              <span>{t(about.tagShuakhevi)}</span>
              <span>MAP</span>
            </div>
          </div>
          <div>
            <span className="lw-kicker">{t(about.s2Kicker)}</span>
            <h2 className="lw-h-title">{t(about.s2Title)}</h2>
            <p>{t(about.s2P1)}</p>
            <p>{t(about.s2P2)}</p>
          </div>
        </div>
      </section>

      <section className="lw-about">
        <div className="lw-wrap lw-frame-grid">
          <div>
            <span className="lw-kicker">{t(about.s3Kicker)}</span>
            <h2 className="lw-h-title">{t(about.s3Title)}</h2>
            <p>{t(about.s3P1)}</p>
          </div>
          <div className="lw-about-visual">
            <img src={hero4} alt="Adjarian Film Tales school workshop" />
            <div className="lw-reel-overlay" />
            <div className="lw-tag">
              <span>{t(about.tagWorkshop)}</span>
              <span>9:16</span>
            </div>
          </div>
        </div>
      </section>

      <section className="lwt-split">
        <div className="lw-wrap lw-frame-grid">
          <div className="lw-about-visual lw-about-visual--building">
            <img src={cultureCenterBuilding} alt="The Shuakhevi Culture Center building" />
            <div className="lw-tag">
              <span>{t(about.tagCultureCenter)}</span>
              <span>SHUAKHEVI</span>
            </div>
          </div>
          <div>
            <span className="lw-kicker">{t(about.cultureCenterKicker)}</span>
            <h2 className="lw-h-title">{t(about.cultureCenterTitle)}</h2>
            <p>{t(about.cultureCenterP1)}</p>
          </div>
        </div>
      </section>

      <section className="lw-about">
        <div className="lw-wrap lw-frame-grid">
          <div className="lw-about-visual-duo">
            <div className="lw-about-visual">
              <img src={hero5} alt="Audience watching a film screening" />
              <div className="lw-reel-overlay" />
              <div className="lw-tag">
                <span>{t(about.tagFestival)}</span>
                <span>9:16</span>
              </div>
            </div>
            <div className="lw-about-visual">
              <img src={hero5b} alt="Team members in the mountains of Adjara" />
              <div className="lw-reel-overlay" />
              <div className="lw-tag">
                <span>{t(about.tagAdjara)}</span>
                <span>9:16</span>
              </div>
            </div>
          </div>
          <div>
            <span className="lw-kicker">{t(about.s4Kicker)}</span>
            <h2 className="lw-h-title">{t(about.s4Title)}</h2>
            <p>{t(about.s4P1)}</p>
          </div>
        </div>
      </section>

      <section className="lw-history-intro" id="lw-history">
        <div className="lw-wrap lw-history-intro-grid">
          <div className="lw-history-intro-copy">
            <div className="lw-section-head">
              <span className="lw-kicker">{t(history.eyebrow)}</span>
              <h2 className="lw-h-title">{t(history.title)}</h2>
            </div>
            <p>{t(history.intro1)}</p>
            <p>{t(history.intro2)}</p>
            <p>{t(history.intro3)}</p>
            <p>{t(history.intro4)}</p>
          </div>
          <div className="lw-history-intro-media">
            <img src={historyBtsFilming} alt="Behind the scenes filming a smart-film" />
          </div>
        </div>
      </section>

      <section className="lw-about lw-future">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(history.futureKicker)}</span>
            <h2 className="lw-h-title">{t(history.futureTitle)}</h2>
          </div>
          <p>
            <strong>{t(history.futureLead)}</strong> {t(history.futureP1)}
          </p>
          <p>{t(history.futureP2)}</p>
        </div>
      </section>

      <section className="lw-history">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <h2 className="lw-h-title">{t(history.yearByYearTitle)}</h2>
          </div>

          <div className="lwt-year-list">
            <div className="lwt-year-card">
              <div className="lwt-year-media">
                <img src={year2022} alt="Adjarian Film Tales, 2022" />
              </div>
              <div className="lwt-year-body">
                <button
                  className="lwt-year-toggle"
                  onClick={() => toggle(2022)}
                  aria-expanded={openYear === 2022}
                >
                  <span className="lw-tl-year">2022</span>
                  <FontAwesomeIcon
                    icon={openYear === 2022 ? faChevronUp : faChevronDown}
                  />
                </button>
                <div
                  className={`lwt-year-detail ${
                    openYear === 2022 ? "open" : ""
                  }`}
                >
                  <p>{t(history.y2022body)}</p>
                </div>
              </div>
            </div>

            <div className="lwt-year-card">
              <div className="lwt-year-media">
                <img src={year2023} alt="Adjarian Film Tales, 2023" />
              </div>
              <div className="lwt-year-body">
                <button
                  className="lwt-year-toggle"
                  onClick={() => toggle(2023)}
                  aria-expanded={openYear === 2023}
                >
                  <span className="lw-tl-year">2023</span>
                  <FontAwesomeIcon
                    icon={openYear === 2023 ? faChevronUp : faChevronDown}
                  />
                </button>
                <div
                  className={`lwt-year-detail ${
                    openYear === 2023 ? "open" : ""
                  }`}
                >
                  <p>{t(history.y2023body)}</p>
                </div>
              </div>
            </div>

            <div className="lwt-year-card">
              <div className="lwt-year-media">
                <img src={year2025} alt="Adjarian Film Tales, 2025" />
              </div>
              <div className="lwt-year-body">
                <button
                  className="lwt-year-toggle"
                  onClick={() => toggle(2025)}
                  aria-expanded={openYear === 2025}
                >
                  <span className="lw-tl-year">2025</span>
                  <FontAwesomeIcon
                    icon={openYear === 2025 ? faChevronUp : faChevronDown}
                  />
                </button>
                <div
                  className={`lwt-year-detail ${
                    openYear === 2025 ? "open" : ""
                  }`}
                >
                  <p>{t(history.y2025body)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="lw-history-intro lw-program">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(about.programKicker)}</span>
            <h2 className="lw-h-title">{t(about.programTitle)}</h2>
          </div>
          <p>{t(about.programP1)}</p>
        </div>
      </section>

      <section className="lw-about lw-future">
        <div className="lw-wrap">
          <div className="lw-section-head">
            <span className="lw-kicker">{t(about.filmmakerExperienceKicker)}</span>
            <h2 className="lw-h-title">{t(about.filmmakerExperienceTitle)}</h2>
          </div>
          <p>{t(about.filmmakerExperienceP1)}</p>
        </div>
      </section>

      <footer className="lw-footer">
        <div className="lw-wrap lw-foot-bottom">
          <span>{t(footer.est)}</span>
          <Link to="/">{t(footer.backHome)}</Link>
        </div>
      </footer>
    </div>
  );
};

export default AboutUs;
